import {
    Button, Card, Input, Select, Space, Spin,
} from 'antd';
import { YMaps, Map } from '@pbe/react-yandex-maps';
import { useEffect, useState } from 'react';
import { ClearOutlined } from '@ant-design/icons';
import MasterPlacemark from './master-placemark';
import { ITrackingMapLayout } from '../../types/layouts/tracking-map';
import { useTrackingMapOrders } from '../../hooks/useTrackingMapOrders';
import OrderPlacemark from './order-placemark';
import ModalEdit from '../modal-edit';
import { useGeolocationAddress } from '../../hooks/useGeolocationAddress';
import { useYandexMapToken } from '../../hooks/useYandexMapToken';
import { useTrackingMapMasters } from '../../hooks/useTrackingMapMasters';

function TrackingMap({ channel, title }: ITrackingMapLayout) {
    const { masters } = useTrackingMapMasters(channel);
    const { orders, modal } = useTrackingMapOrders();
    const [search, setSearch] = useState<string>();
    const [searchType, setSearchType] = useState<'masters'|'orders'>('orders');
    const [showOnly, setShowOnly] = useState<'masters'|'orders'>();
    const [showOnlyFreeMasters, setShowOnlyFreeMasters] = useState(false);
    const map = useGeolocationAddress();
    const yandexMap = useYandexMapToken();

    useEffect(() => {
        yandexMap.getTokens();
    }, []);

    const titleEl = (
        <Space direction="horizontal" wrap>
            <Space direction="horizontal">
                <h5 className="ant-typography mb-0">
                    {title}
                </h5>
                <Button disabled={showOnly === 'orders'} type="link" onClick={() => setShowOnly('orders')}>
                    Заказы:
                    {' '}
                    {orders.length}
                </Button>
                <Button disabled={showOnly === 'masters'} type="link" onClick={() => setShowOnly('masters')}>
                    Мастера:
                    {' '}
                    {masters.length}
                </Button>
                <Button type="link" onClick={() => setShowOnlyFreeMasters(!showOnlyFreeMasters)}>
                    Свободен:
                    {' '}
                    {masters.filter((el) => !!el.free).length}
                    {showOnlyFreeMasters && <ClearOutlined />}
                </Button>
                {typeof showOnly === 'string' && (
                    <Button type="link" onClick={() => setShowOnly(undefined)}>
                        Показать все
                    </Button>
                )}
            </Space>
            <Input.Search
                allowClear
                placeholder="Поиск"
                addonBefore={(
                    <Select value={searchType} onChange={setSearchType}>
                        <Select.Option value="orders">Заказы</Select.Option>
                        <Select.Option value="masters">Мастера</Select.Option>
                    </Select>
                )}
                onSearch={setSearch}
            />
        </Space>
    );

    let mastersFiltered = (showOnlyFreeMasters ? masters.filter((el) => el.free) : masters);
    let ordersFiltered = orders;

    if (typeof search === 'string' && search.length > 0) {
        switch (searchType) {
            case 'masters': {
                mastersFiltered = mastersFiltered.filter((el) => el.name.toLowerCase().includes(search.toLowerCase()));
                break;
            }
            case 'orders': {
                ordersFiltered = ordersFiltered.filter((el) => el.id.toLowerCase().includes(search.toLowerCase()));
                break;
            }
        }
    }

    return (
        <Spin spinning={map.loading || yandexMap.loading}>
            <Card extra={titleEl}>
                {map.loaded && (
                    <Space direction="vertical" style={{ width: '100%' }} size="middle">
                        <YMaps query={{ apikey: yandexMap.tokens?.geocoder, suggest_apikey: yandexMap.tokens?.suggest }}>
                            <Map defaultState={{ center: map.center, zoom: 9 }} width="100%" height="calc(100vh - 205px)">
                                {(showOnly === 'masters' || typeof showOnly === 'undefined') && mastersFiltered.map((obj, index) => (
                                    <MasterPlacemark
                                        key={index}
                                        data={obj}
                                        geometry={[obj.geolocation.latitude, obj.geolocation.longitude]}
                                    />
                                ))}
                                {
                                    (showOnly === 'orders' || typeof showOnly === 'undefined')
                                    && !(searchType === 'masters' && typeof search === 'string' && search.length > 0)
                                    && ordersFiltered.map((order) => (
                                        <OrderPlacemark
                                            key={order.id}
                                            order={order}
                                            modal={modal}
                                        />
                                    ))
                                }
                            </Map>
                        </YMaps>
                    </Space>
                )}
            </Card>
            <ModalEdit hook={modal} objectName="orders" />
        </Spin>
    );
}

export default TrackingMap;
